import { Nav, NavItem } from 'react-bootstrap';
import moment from 'moment';
import React, { Component } from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import ReactHighcharts from 'react-highcharts';
import ScreenLoader from '../ScreenLoader/ScreenLoader';
import Message from '../Message/Message';
import Api from '../../helpers/Api';
import './Closings.css';
import _ from 'lodash';

const bookmakerOptions = [
  { value: 'pin', label: 'pin' },
  { value: 'ibc', label: 'ibc' },
  { value: 'isn', label: 'isn' },
  { value: 'sbo', label: 'sbo' },
  { value: 'cmd', label: 'cmd' },
  { value: 'bf', label: 'bf' },
  { value: 'mbook', label: 'mbook' },
  { value: 'bdaq', label: 'bdaq' },
  { value: 'ga288', label: 'ga288' },
];

const triggerOptions = [
  { value: 'pin', label: 'pin' },
  { value: 'bf', label: 'bf' },
  { value: 'mbook', label: 'mbook' },
  { value: 'bdaq', label: 'bdaq' },
];

const sportOptions = [
  { value: 'fb', label: 'fb' },
  { value: 'fb_ht', label: 'fb_ht' },
  { value: 'tennis', label: 'tennis' },
];

const strategyOptions = _.range(10000,10015).map(v => Object.assign({value: v, label: v}))

export default class Closings extends Component {
  static isPrivate = true;

  constructor(props) {
    super(props);
    this.timeouts = [];
    this.cancellers = [];
    this.state = {
      isLoading: false,
      data: [],
      bookmakers: [],
      triggers: [],
      sports: [],
      min_odds: 0,
      max_odds: 0,
      groupBy: 'day',
      strategies: [],
    };
    this.onChangeBookmakers = this.onChangeBookmakers.bind(this);
    this.onChangeTriggers = this.onChangeTriggers.bind(this);
    this.onChangeSports = this.onChangeSports.bind(this);
    this.onChangeStrategies = this.onChangeStrategies.bind(this);
    this.handleGroupBy = this.handleGroupBy.bind(this);
    this.api = new Api('bets-closing', 'post');
  }

  componentDidMount() {
    this.api.start({
      requestBody: this.getRequestBody(),
      onBefore: this.requestWillStart.bind(this),
      onSuccess: this.requestDidComplete.bind(this),
      onError: this.requestDidCatch.bind(this),
    });
    this.triggerOptions = new Api('triggers', 'get').start({
      requestBody: null,
      onBefore: null,
      onSuccess: null,
      onError: null,
    });
    console.log(this.triggerOptions)
  }

  componentWillUnmount() {
    this.api.stop();
  }

  onChangeBookmakers(books) {
    this.setState({ bookmakers: books });
  }

  onChangeTriggers(triggers) {
    this.setState({ triggers });
  }

  onChangeSports(sports) {
    this.setState({ sports });
  }

  onChangeStrategies(strategies) {
    this.setState({ strategies });
  }

  onChangePreset(e) {
    if (e instanceof Object && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    this.api.requestBody = this.getRequestBody();
    this.api.fetch();
  }

  getRequestBody() {
    return {
      triggers: this.state.triggers.map(t => t.value),
      bookmakers: this.state.bookmakers.map(b => b.value),
      min_odds: +this.state.min_odds || -Infinity,
      max_odds: +this.state.max_odds || Infinity,
      sports: this.state.sports.map(s => s.value),
      strategies: this.state.strategies.map(s => s.value),
      groupBy: this.state.groupBy,
    };
  }

  requestWillStart() {
    this.setState({ isLoading: true });
    this.props.updateRefresh(true, false);
  }

  requestDidComplete(data) {
    this.setState({ data, isLoading: false });
    this.props.updateRefresh(false, false);
  }

  requestDidCatch(error) {
    this.setState({ isLoading: false });
    this.props.updateRefresh(false, error instanceof Api.CancelError ? false : error);
  }

  handleGroupBy(groupBy) {
    this.setState({ groupBy }, () => {
      this.onChangePreset();
    });
  }

  render() {
    if (!Array.isArray(this.state.data) || this.state.data.length < 1) {
      return this.state.isLoading
        ? <ScreenLoader />
        : <Message type="warning" text="No data" />;
    }

    return (
      <div className="closings">
        <Nav
          className="closings__tabs"
          bsStyle="tabs"
          activeKey={this.state.groupBy}
          onSelect={this.handleGroupBy}
        >
          <NavItem eventKey={-1}>By trade</NavItem>
          <NavItem eventKey="day">By day</NavItem>
          <NavItem eventKey="week">By week</NavItem>
        </Nav>

        <div className="row">
          <div className="col-md-12 col-lg-9">
            <ProfitGraph data={this.state.data} groupBy={this.state.groupBy} />
          </div>
          <div className="col-md-12 col-lg-3">
            <div className="row">
            <div className="col-lg-12 col-md-3 col-sm-4 col-xs-12 mb">
              <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 mb">
                <div className="input-group">
                  <span className="input-group-addon">Min odds</span>
                  <input
                    type="text"
                    pattern="[0-9]*[.][0-9]+"
                    className="form-control"
                    value={this.state.min_odds}
                    onChange={e => this.setState({ min_odds: e.target.value || "" })}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 mb">
                <div className="input-group">
                  <span className="input-group-addon">Max odds</span>
                  <input
                    type="text"
                    pattern="[0-9]*[.][0-9]+"
                    className="form-control"
                    value={this.state.max_odds}
                    onChange={e => this.setState({ max_odds: e.target.value || "" })}
                  />
                </div>
              </div>
              </div>
              <div className="col-lg-12 col-md-3 col-sm-4 col-xs-12 mb">
                <Select
                  multi
                  value={this.state.sports}
                  onChange={this.onChangeSports}
                  options={sportOptions}
                  placeholder="Sports"
                />
              </div>
              <div className="col-lg-12 col-md-3 col-sm-4 col-xs-12 mb">
                <Select
                  multi
                  value={this.state.triggers}
                  onChange={this.onChangeTriggers}
                  options={this.triggerOptions}
                  placeholder="Triggers"
                />
              </div>
              <div className="col-lg-12 col-md-3 col-sm-4 col-xs-12 mb">
                <Select
                  multi
                  value={this.state.bookmakers}
                  onChange={this.onChangeBookmakers}
                  options={bookmakerOptions}
                  placeholder="Bookmakers"
                />
              </div>
              <div className="col-lg-12 col-md-3 col-sm-4 col-xs-12 mb">
                <Select
                  multi
                  value={this.state.strategies}
                  onChange={this.onChangeStrategies}
                  options={strategyOptions}
                  placeholder="Strategies"
                />
              </div>
              <div className="col-lg-12 col-md-3 col-sm-4 col-xs-12">
                <button
                  className="btn btn-success btn-lg"
                  onClick={() => this.onChangePreset()}
                >Update graph
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class ProfitGraph extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.data.length !== this.props.data.length) { return true; }
    return false;
  }

  render() {
    const xAxis = this.props.groupBy === -1 ? {} : {
      type: 'datetime',
      text: 'Date',
    };
    const xKey = this.props.groupBy === -1 ? (d, i) => i + 1 : d => d.start_time;
    return (<ReactHighcharts config={{
      chart: {
        zoomType: 'x',
      },
      responsive: true,
      title: {
        text: 'Closing EV/Profit Graph',
      },
      xAxis,
      tooltip: {
        formatter() {
          return `${this.series.name}<br/><b>€${this.y.toFixed(1)}</b><br />${moment(this.point.z).format('MMM Do h:mm a')}<br />#${this.point.index + 1}`;
        },
      },
      series: [{
        name: 'Profits',
        data: this.props.data.map((d, i) => ({
          x: xKey(d, i),
          y: d.profit,
          z: d.start_time,
        })),
        turboThreshold: 0,
      }, {
        name: 'Closing EV',
        data: this.props.data.map((d, i) => ({
          x: xKey(d, i),
          y: d.EV,
          z: d.start_time,
        })),
        turboThreshold: 0,
      }],
    }}
    />);
  }
}



// WEBPACK FOOTER //
// ./src/components/Closings/Closings.js